export const STATIC_MAP_URL = 'https://maps.googleapis.com/maps/api/staticmap';
export const styles = [
    {
        elementType: 'geometry.fill',
        stylers: [
            {
                saturation: -5,
            },
        ],
    },
    {
        elementType: 'geometry.stroke',
        stylers: [
            {
                lightness: 5,
            },
        ],
    },
    {
        elementType: 'labels.icon',
        stylers: [
            {
                color: '0x7684cb',
            },
        ],
    },
    {
        elementType: 'labels.text',
        stylers: [
            {
                saturation: 100,
            },
            {
                lightness: 5,
            },
        ],
    },
    {
        elementType: 'labels',
        featureType: 'administrative.land_parcel',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'landscape.man_made',
        stylers: [
            {
                lightness: 5,
            },
        ],
    },
    {
        featureType: 'landscape.natural',
        stylers: [
            {
                color: '0xf0efe6',
            },
        ],
    },
    {
        elementType: 'labels.text',
        featureType: 'poi',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.business',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.medical',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.park',
        stylers: [
            {
                color: '0xbee2b1',
            },
        ],
    },
    {
        elementType: 'labels.icon',
        featureType: 'road',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road.highway',
        stylers: [
            {
                color: '0xffffff',
            },
        ],
    },
    {
        elementType: 'geometry.stroke',
        featureType: 'road.highway',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        elementType: 'labels',
        featureType: 'road.local',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'transit.station.bus',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'transit.station.rail',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'water',
        stylers: [
            {
                color: '0x9edef5',
            },
        ],
    },
];
//# sourceMappingURL=constant.js.map